export function rescopeFunction(fun, scope={}, context=null) {
  if(fun._scope){
    if(fun._context!==context || Object.keys(scope).some(k=>fun._scope[k]!==scope[k])){
      return rescopeFunction(fun._original,Object.assign({},fun._scope,scope),context);
    }else{
      return fun;
    }
  }

  const keys = Object.keys(scope).join(',');
  const $keys = Object.keys(scope).map(key=>`const $${key} = ${key};`).join('\n');
  if(!keys) {throw new Error('Scope is empty');}

  // Parse the user function's declared parameter names so positional slots
  // past the caller's explicit arguments can be filled with scope values
  // matched BY NAME, not by scope-iteration order. Without this alignment,
  // a signature like function(text, control, component, parentControl) would
  // receive scope.control / scope.component for slots 2/3 instead of
  // scope.component / scope.parentControl — silently wrong values.
  const funStr = fun.toString();
  const pMatch = funStr.match(/function[^(]*\(([^)]*)\)/)
              || funStr.match(/^\s*\(([^)]*)\)\s*=>/)
              || funStr.match(/^\s*([A-Za-z_$][A-Za-z0-9_$]*)\s*=>/);
  const userParams = pMatch
    ? pMatch[1].split(',')
        .map(p => p.trim().split('=')[0].trim().replace(/^\.\.\./, ''))
        .filter(Boolean)
    : [];

  // For each declared user param, decide its substitution strategy at wrapper
  // build time:
  //   - if the param name matches a scope key → emit the scope identifier so
  //     it resolves to the correct value (new, name-aligned behavior);
  //   - otherwise → emit a LEGACY marker so the call-time loop falls back to
  //     the pre-fix scope-iteration positional order, preserving any older
  //     formatter/trigger that relied on the (undocumented but real) old
  //     positional spread.
  // Per-call sentinel that can't collide with anything in scope.
  const LEGACY_MARK = '__rescopeFunction_legacy_fallback__';
  const namedSubsExpr = userParams
    .map(name => (name in scope) ? name : JSON.stringify(LEGACY_MARK))
    .join(',');
  const scopeKeysLit = JSON.stringify(Object.keys(scope));
  const legacyMarkLit = JSON.stringify(LEGACY_MARK);

  const res = Function(`
  const {${keys}} = this.scope;
  ${$keys}
  const $_cb = ${fun};
  const _named = [${namedSubsExpr}];
  const _scopeKeys = ${scopeKeysLit};
  const _scope = this.scope;
  const _args = arguments;
  const _final = [];
  const _max = Math.max(_args.length, _named.length);
  for (let _i = 0; _i < _max; _i++) {
    if (_i < _args.length) {
      _final.push(_args[_i]);
    } else if (_named[_i] !== ${legacyMarkLit}) {
      _final.push(_named[_i]);
    } else {
      const _legacyIdx = _i - _args.length;
      _final.push(_legacyIdx < _scopeKeys.length ? _scope[_scopeKeys[_legacyIdx]] : undefined);
    }
  }
  return $_cb.apply(this.context, _final);`)
  .bind({scope,context});

  res._scope = scope;
  res._context = context;
  res._original = fun;
  return res;
}

